export default "__VITE_ASSET__CzDe9ta2__"